import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  OnChanges,
} from '@angular/core';
import { Interests, QuestionI, TypeDataInProgress } from '@models';
import { Observable } from 'rxjs';
import { ScheduleVisitService } from '../schedule-visit.service';

@Component({
  selector: 'ggi-journey-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
})
export class PreferencesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() typeProject: string;
  @Input() saveData: boolean;
  @Output() canUserContinue = new EventEmitter<boolean>();
  @Output() doRequest = new EventEmitter<boolean>();

  public getInterests$: Observable<any>;

  public interestExtraNotes = '';
  public questionI: QuestionI;
  public answer: string;
  public openAnswer: string;

  private interests: Interests[] = [];
  private isOpenAnswer: boolean;

  constructor(private readonly service: ScheduleVisitService) {}

  public ngOnInit(): void {
    this.getInterests(this.typeProject);
    this.getQuestion();
  }

  public ngOnDestroy(): void {
    this.savePreferences();
  }

  public ngOnChanges(): void {
    if (this.saveData) {
      this.savePreferences();
      this.doRequest.emit(true);
    }
  }

  private savePreferences(): void {
    this.service.saveDataInProgress(
      {
        interests: this.interests,
        interestExtraNotes: this.interestExtraNotes,
        question: this.questionI.question,
        answer: this.isOpenAnswer ? this.openAnswer : this.answer,
      },
      TypeDataInProgress.preferences
    );
  }

  private getInterests(typeProject: string): void {
    this.getInterests$ = this.service.getInterests(typeProject);
  }

  public onChangeInterests(item: Interests): void {
    const exists = this.interests.find((e) => e.id === item.id);

    if (!exists) {
      this.interests.push(item);
    } else {
      this.interests = this.interests.filter((e) => e.id !== item.id);
    }

    this.validateForm();
  }

  public validateForm(): void {
    this.isOpenAnswer = false;
    const openAnswerItem = this.questionI.answers.find((x) => x.isOpen);
    if (openAnswerItem) {
      this.isOpenAnswer = openAnswerItem.text === this.answer;
    }
    if (
      !this.interests.length ||
      this.interestExtraNotes.length > 300 ||
      !this.answer ||
      (this.isOpenAnswer && !this.openAnswer)
    ) {
      this.canUserContinue.next(false);
      return;
    }

    this.canUserContinue.next(true);
  }

  public focusOpen(): void {
    this.answer = this.questionI.answers.find((x) => x.isOpen).text;
    this.validateForm();
  }

  private getQuestion(): void {
    this.service.getQuestion().subscribe((response) => {
      this.questionI = response.response;
    });
  }
}
